import DeleteTeam from './DeleteTeam';

export default DeleteTeam;
